module.exports = __webpack_public_path__ + "img/ico060.79ccfca3.svg";